var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _path13, _path14, _path15, _g, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _use20, _use21, _use22, _use23, _use24, _use25, _path64, _use26, _use27, _use28, _use29, _use30, _use31, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _use32, _path76, _path77, _path78, _path79, _use33, _use34, _g2, _path80, _path81, _path82, _path83, _use35, _use36, _path84, _use37, _use38, _use39, _path85, _use40, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _use41, _use42, _use43, _use44, _use45, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _use46, _use47, _use48, _use49, _path134, _use50, _use51, _use52, _use53, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _use54, _use55, _use56, _path144, _path145, _path146, _path147, _path148, _path149, _use57, _use58, _use59, _use60, _use61, _use62, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _use63, _use64, _use65, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _use66, _use67, _use68, _use69, _use70, _use71, _path174, _path175, _path176, _g3, _path177, _path178, _path179, _path180, _path181, _path182, _use72, _use73, _use74, _path183, _path184, _path185, _path186, _path187, _path188, _use75, _use76, _use77, _use78, _use79, _use80, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _use81, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _use82, _use83, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _use84, _use85, _use86, _use87, _use88, _use89, _use90, _use91, _use92, _use93, _path240, _path241, _path242, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundStart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    style: {
      backgroundColor: "#396afc"
    },
    viewBox: "0 0 390 844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "reuse-0",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m35.29 737.65 37.03.86L39.5 771.2l-47.67-4.76 28.79-25.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-1",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M35.56 741.25c8.97-1.82 16.29-.73 17.55 3.03 1.56 4.64-6.68 11.6-18.4 15.52-11.71 3.94-22.48 3.36-24.03-1.28-1.24-3.7 3.72-8.85 11.7-12.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-2",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M36.97 743.45c5.57-.74 9.89.18 10.72 2.65 1.16 3.45-4.98 8.63-13.7 11.56-8.72 2.92-16.73 2.5-17.89-.96-.81-2.42 1.96-5.7 6.7-8.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-3",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m15.95 722.89 8.63 25.72c-3.12 1.91-4.9 4.13-4.35 5.8.84 2.48 6.61 2.79 12.9.68s10.7-5.84 9.87-8.33c-.56-1.66-3.32-2.35-6.96-2L22.62 704.8c-.4-1.18-3.28-1.28-6.45-.22-3.16 1.06-5.4 2.88-5 4.07l3.12 9.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-4",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m-8.17 766.44 4.61 13.74 48.19 4.58 33.3-32.85-2.85-8.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-5",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M5.34 764.7c2.5-.84 4.13-2.67 3.65-4.08-.47-1.42-2.88-1.89-5.37-1.05-2.49.83-4.12 2.66-3.65 4.07.48 1.42 2.88 1.89 5.37 1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-6",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M323.78 92.72c-.16-4.09 1.98-9.86-5.88-8.38-.05-.71-.32-.96-.32-.96-1.35-.32-2.1.01-2.1.01-2.16 15.2-2.17 33.1-2.17 33.1 2.6.25 3.24-.7 3.4-1.24.92.42 3.39 1.3 5.3-.16 2.42-1.83 1.93-18.23 1.77-22.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-7",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M369.01 108.82c.28-.32 18-28.87-14.05-45.4 0 0-27.1-16.18-44.28 16.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-8",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M316.13 80.6s10.92-28.19 38.15-14.15c0 0 26.2 13.3 11.5 37.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-9",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M307.86 85.43s-1.87.48-2.14 1.27c-.28.8-2.57 18.6-1.66 24.75 0 0 .7 1.16 1.64 1.39 0 0-.13 1.67.52 2.23.66.56 5.23 1.42 6.16 1.42 0 0-.05-19.66 2.18-31.46 0 0-.7-.7-1.44.33 0 0-.74 10.67-.88 11.19-.14.5-.08 3.21-2.97 3.18-2.88-.03-2.63-4.32-1.41-14.3ZM317.9 84.34s-2.51 29.1-1.2 30.91M351.32 105.28c3.35-2.35 6.63-7.56 10.24-.42.59-.4.94-.33.94-.33 1.08.88 1.27 1.67 1.27 1.67-10.76 10.96-24.96 21.83-24.96 21.83-1.8-1.9-1.42-3-1.09-3.44-.9-.48-3.09-1.9-3.1-4.32-.01-3.03 13.31-12.6 16.7-14.99ZM366.79 113.5s.75 1.77.29 2.47c-.46.7-13.22 13.34-18.66 16.35 0 0-1.35.15-2.1-.45 0 0-1.25 1.12-2.09.94-.84-.19-4.3-3.3-4.86-4.03 0 0 15.64-11.91 23.66-20.85 0 0 .98.14.62 1.35 0 0-8.03 7.07-8.36 7.5-.32.41-2.5 2-.72 4.28 1.78 2.28 5.03-.53 12.22-7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-10",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M361.56 104.86s-21.6 19.68-23.84 19.73M324.71 61.36s2.01-18.88 5.32-18.52c3.31.36 11.62 13.88 11.62 13.88s-9.23-1.55-16.94 4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-11",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M327.13 59.53s1.67-12.3 3.48-11.99c1.82.32 7.55 8.96 7.55 8.96M376.17 85.48s12.8-14.02 10.35-16.26c-2.46-2.24-18.1.5-18.1.5s7.28 5.89 7.75 15.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-12",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M375.94 82.46s8.11-9.4 6.67-10.56c-1.44-1.15-11.7.3-11.7.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-13",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M310.57 84.96s-1.5 9.02-1.23 12M356.51 119.28c.25-.25 7.65-6.48 8.93-8.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-14",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m51.63 185.37 4.35 2.28a4.08 4.08 0 0 1 1.71 5.5l-19.61 37.38a4.08 4.08 0 0 1-5.5 1.72l-63.55-33.35a4.08 4.08 0 0 1-1.71-5.5l19.61-37.38a4.08 4.08 0 0 1 5.5-1.7l7.85 4.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-15",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "m-23.36 202.74 22.61-43.1a4.08 4.08 0 0 1 5.5-1.71L46 179.58a4.08 4.08 0 0 1 1.72 5.49l-22.68 43.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-16",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "m24.02 173.22-.14 5.89 4.77 3.46-5.65 1.69-1.82 5.6-3.35-4.85h-5.9l3.59-4.68-1.83-5.6 5.56 1.96 4.77-3.47ZM32.05 228.38a1.37 1.37 0 1 0-.81-2.61 1.37 1.37 0 0 0 .81 2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-17",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "m310.45 732.88-7.35-3.56 3.55-7.35a3.92 3.92 0 0 0-1.81-5.22l-1.12-.54a3.92 3.92 0 0 0-5.22 1.82l-3.56 7.35-7.35-3.56a3.92 3.92 0 0 0-5.22 1.82l-.54 1.11a3.92 3.92 0 0 0 1.82 5.22l7.35 3.56-3.56 7.35a3.92 3.92 0 0 0 1.82 5.22l1.11.54c1.94.94 4.29.12 5.22-1.81l3.56-7.36 7.35 3.56c1.94.94 4.29.12 5.22-1.81l.54-1.12a3.92 3.92 0 0 0-1.81-5.22ZM346.89 717.84c6.82-16.54 4.2-33.34-6.43-38.48-10.62-5.14-25.42 3.23-34.16 18.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-18",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M340.8 714.89c4.33-11.33 2.4-22.63-4.88-26.15-7.27-3.52-17.34 1.98-23.53 12.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-19",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m409.79 748.52-100.56-48.65a4.82 4.82 0 0 0-1.7-.47c-14.1-4.66-29.91-.4-39 11.76-11.48 15.35-7.89 37.42 8.02 49.32a36.47 36.47 0 0 0 28.2 6.82l58.84 28.47a36.9 36.9 0 0 0 10.28 11.8c15.9 11.89 38.1 9.09 49.56-6.25 10.39-13.89 8.43-33.3-3.83-45.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-20",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M313.75 747.74a22.61 22.61 0 1 0-31.98-31.98 22.61 22.61 0 0 0 31.98 31.98ZM413 795.76a22.61 22.61 0 1 0-31.98-31.98A22.61 22.61 0 0 0 413 795.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-21",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "m406.8 781.65-18.05-8.73a5.28 5.28 0 0 1-2.44-7.03 5.28 5.28 0 0 1 7.04-2.45l18.04 8.73a5.28 5.28 0 0 1 2.45 7.04 5.28 5.28 0 0 1-7.04 2.44ZM400.64 794.38l-18.04-8.73a5.28 5.28 0 0 1-2.45-7.04 5.28 5.28 0 0 1 7.04-2.45l18.04 8.73a5.28 5.28 0 0 1 2.45 7.04 5.28 5.28 0 0 1-7.04 2.45ZM328.47 760.13l-8.27-4a2.25 2.25 0 0 1-1.04-3 2.25 2.25 0 0 1 2.99-1.04l8.27 4a2.25 2.25 0 0 1 1.04 3 2.25 2.25 0 0 1-2.99 1.03ZM343.96 767.62l-8.27-4a2.24 2.24 0 0 1-1.04-3 2.25 2.25 0 0 1 2.99-1.03l8.27 4a2.24 2.24 0 0 1-1.95 4.03ZM359.45 775.11l-8.28-4a2.25 2.25 0 0 1-1.04-3 2.25 2.25 0 0 1 3-1.03l8.27 4a2.25 2.25 0 0 1 1.04 3 2.25 2.25 0 0 1-3 1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-22",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m30.57 322.18 7.64-3.58c1.38-.65 3-.06 3.65 1.31l31.77 67.74a10.96 10.96 0 0 1-5.27 14.58l-51.42 24.11a10.97 10.97 0 0 1-14.58-5.27l-31.77-67.73c-.64-1.37-.05-3 1.32-3.65l49.97-23.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-23",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M37.23 328.33 62.88 383c2 4.27-.05 9.45-4.57 11.57l-40.67 19.07c-4.53 2.13-9.82.39-11.82-3.88l-25.65-54.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-24",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.97 346.36 13.4-6.28-6.93 19.17 11.48-5.38-3.25 37.2-6.58-25.58-13.06 6.12 1.55-20.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-25",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M204.31 643.27a21.93 21.93 0 1 1-4.43-3.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-26",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M188.8 665.57a6.8 6.8 0 1 0 0-13.62 6.8 6.8 0 0 0 0 13.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-27",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M188.8 661.95a3.2 3.2 0 1 0 0-6.38 3.2 3.2 0 0 0 0 6.38ZM172.6 673.8s-.32-4.18 3.53-3.86c3.85.32 4.17-.64 4.5-2.89.31-2.25 4.17-3.21 4.17-3.21M195.4 657.42s-.33-4.17 3.53-3.85c3.85.32 4.17-.65 4.5-2.9.31-2.24 4.16-3.2 4.16-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-28",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m430.02 274.03-83.04 36.49 73.13 53.66 9.91-90.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-29",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M47.23 64.73c-.43-3.43-.58-7.42.95-7.65 2.52-.37 7.87 2.6 11.79-6l7-3 .02.03.68-.32.69-.3-.01-.01 6.91-3.2c9.02 2.83 10.38-3.14 12.34-4.76 1.97-1.62 8.47 6.96 9.33 8.22.86 1.25 10.2 9.16 16.84 3.67 6.65-5.5 2.59-12.93 2.59-12.93-.63-3.74-16.27-28.82-25.61-35.39S74.44 6.63 74.44 6.63l-20.27 9.03-1.37.61-20.27 9.04s-12.18-1.58-13.54 9.75c-1.36 11.34 6.83 39.74 9.2 42.71 0 0 2.8 7.99 11.34 6.72 8.52-1.27 8.89-13.5 8.53-14.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-30",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m68.1 9.46 9.3 20.89-29.34 13.08-7.96-17.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-31",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m54.09 22.32-.28-2.61 4.14 4.59 5.65-2.52-3.1 5.36 4.15 4.6-6.05-1.3-3.09 5.36-.65-6.15-6.05-1.28 5.65-2.51-.12-1.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-32",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "m55.45 50.19-1.53-.6.59-1.53a1.26 1.26 0 0 0-.72-1.62 1.26 1.26 0 0 0-1.62.72l-.59 1.53-1.53-.6a1.26 1.26 0 0 0-1.62.73c-.25.64.07 1.37.71 1.61l1.54.6-.6 1.53c-.24.65.08 1.37.72 1.62.65.25 1.37-.07 1.62-.72l.6-1.53 1.53.6c.64.24 1.37-.08 1.62-.72a1.26 1.26 0 0 0-.72-1.62ZM82.08 37.42l-1.54-.6.6-1.53a1.26 1.26 0 0 0-.72-1.62 1.26 1.26 0 0 0-1.62.72l-.6 1.53-1.53-.6a1.26 1.26 0 0 0-1.62.73c-.25.64.08 1.37.72 1.61l1.53.6-.59 1.53a1.26 1.26 0 0 0 2.34.9l.59-1.53 1.54.6c.64.24 1.37-.08 1.61-.72a1.26 1.26 0 0 0-.71-1.62ZM87.66 11.87l-6.4 3.07a2.46 2.46 0 0 1-3.28-1.15 2.46 2.46 0 0 1 1.16-3.27l6.4-3.07a2.46 2.46 0 0 1 3.27 1.15 2.46 2.46 0 0 1-1.15 3.27ZM91.07 18.98l-6.4 3.07a2.46 2.46 0 0 1-3.28-1.15 2.46 2.46 0 0 1 1.16-3.27l6.4-3.07a2.46 2.46 0 0 1 3.28 1.15 2.46 2.46 0 0 1-1.16 3.27ZM30.04 35.6a2.51 2.51 0 1 0-3.15-3.9 2.51 2.51 0 0 0 3.15 3.9ZM35.39 46.75a2.51 2.51 0 1 0-3.16-3.9 2.51 2.51 0 0 0 3.16 3.9ZM38.57 38.14a2.51 2.51 0 1 0-3.55-3.55 2.51 2.51 0 0 0 3.55 3.55ZM25.23 44.42a2.51 2.51 0 1 0 0-5.02 2.51 2.51 0 0 0 0 5.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-33",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m117.77 352.23-22.28 9.8 19.62 14.4 2.66-24.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-34",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m284.47-4.86-40.14 18.7 35.35 27.5 4.8-46.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-35",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m97.82 105.46 10.72-12.4a4.06 4.06 0 0 0-.41-5.7 4.06 4.06 0 0 0-5.7.42l-9.96 11.5-9.95-11.5a4.06 4.06 0 0 0-5.7-.42 4.06 4.06 0 0 0-.41 5.7l10.72 12.4-10.72 12.4a4.06 4.06 0 0 0 .4 5.7 4.06 4.06 0 0 0 5.71-.41l9.95-11.5 9.95 11.5a4.06 4.06 0 0 0 5.7.41 4.06 4.06 0 0 0 .42-5.7l-10.72-12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-36",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m320.1 368.67 11.23-12.98a4.25 4.25 0 0 0-.43-5.98 4.25 4.25 0 0 0-5.98.43L314.5 362.2l-10.43-12.06a4.25 4.25 0 0 0-5.97-.43 4.25 4.25 0 0 0-.44 5.98l11.24 12.98-11.23 12.99a4.25 4.25 0 0 0 .43 5.97 4.25 4.25 0 0 0 5.97-.43l10.43-12.05 10.42 12.05a4.25 4.25 0 0 0 5.98.44 4.25 4.25 0 0 0 .43-5.98l-11.23-12.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-37",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M338.73 561.87a33.2 33.2 0 0 0-3.83 6.76l.1.22 21.33 28.38c.9 1.2 2.6 1.43 3.8.53l48.86-36.72c1.2-.9 1.44-2.6.54-3.8l-14.39-19.13v-.01l-6.78-9.04-.16-.2h-.02c-7.45.55-19.4 6.1-30.94 14.78a95.07 95.07 0 0 0-15.95 14.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-38",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "m350 588.63 4.34-.9 7.01 8.99M342.32 557.18c.05.23 25.74 34.24 25.74 34.24M375.15 532.9l25.8 34.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-39",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M383.24 556.47a12.45 12.45 0 0 1-12.41 18.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-40",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M368.09 573.22a12.45 12.45 0 1 1 13.36-18.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-41",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M378.76 550.54c1.9-1.65 3.33-2.42 3.96-1.97 1.46 1.06-1.98 8.34-7.7 16.26-5.72 7.92-11.54 13.48-13.01 12.42-.72-.52-.26-2.53 1.08-5.39"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M-11 734.81h86.16v39.23H-11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M7.66 737.52h48.51v27.76H7.66z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M13.08 740.35h37.6v22.1h-37.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M8.28 701h37.65v58.34H8.28z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M-11 740.57h91.93v47.09H-11z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M-2.97 756.29h14.93v11.65H-2.97z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M-11 734.81h86.16v39.23H-11z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M7.66 737.52h48.51v27.76H7.66z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M13.08 740.35h37.6v22.1h-37.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M8.28 701h37.65v58.34H8.28z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M-11 740.57h91.93v47.09H-11z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M-2.97 756.29h14.93v11.65H-2.97z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-1",
    strokeMiterlimit: 10
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-2",
    strokeMiterlimit: 10
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-3",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-4",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-5",
    strokeMiterlimit: 10
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-1",
    strokeMiterlimit: 10
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-2",
    strokeMiterlimit: 10
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-3",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-4",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-5",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M20.7 780.97c11.83 1.04 21.37 2.47 21.3 3.2-.06.72-9.7.46-21.53-.58-11.82-1.04-21.36-2.47-21.3-3.2.07-.72 9.7-.46 21.53.58Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M20.7 780.97c11.83 1.04 21.37 2.47 21.3 3.2-.06.72-9.7.46-21.53-.58-11.82-1.04-21.36-2.47-21.3-3.2.07-.72 9.7-.46 21.53.58Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M7.09 779.3h27.59v6.67H7.09z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M54.12 736.68c11.87.17 21.49.89 21.48 1.61-.01.73-9.64 1.18-21.52 1-11.87-.16-21.49-.88-21.48-1.6.02-.73 9.65-1.18 21.52-1.01Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M54.12 736.68c11.87.17 21.49.89 21.48 1.61-.01.73-9.64 1.18-21.52 1-11.87-.16-21.49-.88-21.48-1.6.02-.73 9.65-1.18 21.52-1.01Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M40.56 735.49h27.7v5.65h-27.7z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M21.15 734.29c3.76 11.26 6.24 20.58 5.56 20.8-.69.24-4.3-8.7-8.05-19.97-3.75-11.26-6.24-20.58-5.55-20.81.69-.23 4.29 8.72 8.04 19.98Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M21.15 734.29c3.76 11.26 6.24 20.58 5.56 20.8-.69.24-4.3-8.7-8.05-19.97-3.75-11.26-6.24-20.58-5.55-20.81.69-.23 4.29 8.72 8.04 19.98Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M13.82 721.86h11.76v26.51H13.82z",
    style: {
      mixBlendMode: "overlay"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M299.14 650H292v7.14h7.14V650Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M299.14 650H292v7.14h7.14V650Z"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#u)"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M310.44 80.36h16.34v39.01h-16.34z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M307.84 56.62h69.14v55.06h-69.14z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M313.27 59.67h59.81v47.03h-59.81z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M301 81.95h16.45v37.37H301z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M313.49 82.23h7.24v35.56h-7.24z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M331.75 98.4h34.94v32.73h-34.94z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M336.22 105.01h33.86v30.64h-33.86z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M335.66 102.24h28.49v25.21h-28.49z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M321.69 40h23.63v25.21h-23.63z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M324.29 44.69h16.57v17.02h-16.57z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M364.55 65.5h25.16v23.97h-25.16z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M368.73 68.61h16.9v16.45h-16.9z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M310.44 80.36h16.34v39.01h-16.34z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M307.84 56.62h69.14v55.06h-69.14z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M313.27 59.67h59.81v47.03h-59.81z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M301 81.95h16.45v37.37H301z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M313.49 82.23h7.24v35.56h-7.24z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M331.75 98.4h34.94v32.73h-34.94z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M336.22 105.01h33.86v30.64h-33.86z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M335.66 102.24h28.49v25.21h-28.49z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M321.69 40h23.63v25.21h-23.63z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M324.29 44.69h16.57v17.02h-16.57z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M364.55 65.5h25.16v23.97h-25.16z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M368.73 68.61h16.9v16.45h-16.9z"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-6",
    strokeMiterlimit: 10
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-7",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-8",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-9",
    strokeMiterlimit: 10
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-10",
    strokeMiterlimit: 10
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-11",
    strokeMiterlimit: 10
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-12",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M310.44 80.36h16.34v39.01h-16.34z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "M307.84 56.62h69.14v55.06h-69.14z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M313.27 59.67h59.81v47.03h-59.81z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M301 81.95h16.45v37.37H301z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M313.49 82.23h7.24v35.56h-7.24z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M331.75 98.4h34.94v32.73h-34.94z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M336.22 105.01h33.86v30.64h-33.86z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "M335.66 102.24h28.49v25.21h-28.49z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "M321.69 40h23.63v25.21h-23.63z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "M324.29 44.69h16.57v17.02h-16.57z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "M364.55 65.5h25.16v23.97h-25.16z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae)",
    d: "M368.73 68.61h16.9v16.45h-16.9z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M310.44 80.36h16.34v39.01h-16.34z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "M307.84 56.62h69.14v55.06h-69.14z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "M313.27 59.67h59.81v47.03h-59.81z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai)",
    d: "M301 81.95h16.45v37.37H301z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aj)",
    d: "M313.49 82.23h7.24v35.56h-7.24z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "M331.75 98.4h34.94v32.73h-34.94z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "M336.22 105.01h33.86v30.64h-33.86z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#am)",
    d: "M335.66 102.24h28.49v25.21h-28.49z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#an)",
    d: "M321.69 40h23.63v25.21h-23.63z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ao)",
    d: "M324.29 44.69h16.57v17.02h-16.57z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ap)",
    d: "M364.55 65.5h25.16v23.97h-25.16z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aq)",
    d: "M368.73 68.61h16.9v16.45h-16.9z"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-6",
    strokeMiterlimit: 10
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-7",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-8",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-9",
    strokeMiterlimit: 10
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-10",
    strokeMiterlimit: 10
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-11",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M375.94 82.46s8.11-9.4 6.67-10.56c-1.44-1.15-11.7.3-11.7.3M323.78 92.72c-.16-4.09 1.98-9.86-5.88-8.38-.05-.71-.32-.96-.32-.96-1.35-.32-2.1.01-2.1.01-2.16 15.2-2.17 33.1-2.17 33.1 2.6.25 3.24-.7 3.4-1.24.92.42 3.39 1.3 5.3-.16 2.42-1.83 1.93-18.23 1.77-22.37Z"
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-7",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-8",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-9",
    strokeMiterlimit: 10
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-10",
    strokeMiterlimit: 10
  })), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-11",
    strokeMiterlimit: 10
  })), _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-12",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar)",
    d: "M315.99 98.57c.6-7.58 1.38-13.7 1.74-13.67.36.02.16 6.2-.44 13.77-.6 7.58-1.37 13.7-1.73 13.67-.37-.03-.17-6.2.43-13.77Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M315.99 98.57c.6-7.58 1.38-13.7 1.74-13.67.36.02.16 6.2-.44 13.77-.6 7.58-1.37 13.7-1.73 13.67-.37-.03-.17-6.2.43-13.77Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#as)",
    d: "M314.06 88.79h5.54v19.22h-5.54z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#at)",
    d: "M323.19 102.25c.6-7.58 1.38-13.7 1.74-13.67.36.03.17 6.2-.43 13.77-.6 7.58-1.38 13.7-1.74 13.67-.36-.03-.17-6.2.43-13.77Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M323.19 102.25c.6-7.58 1.38-13.7 1.74-13.67.36.03.17 6.2-.43 13.77-.6 7.58-1.38 13.7-1.74 13.67-.36-.03-.17-6.2.43-13.77Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#au)",
    d: "M321.24 92.52h5.54v19.16h-5.54z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#av)",
    d: "M303.74 97.34c.6-7.58 1.38-13.7 1.74-13.67.37.02.17 6.2-.43 13.77-.6 7.58-1.38 13.7-1.74 13.67-.36-.03-.17-6.2.43-13.77Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M303.74 97.34c.6-7.58 1.38-13.7 1.74-13.67.37.02.17 6.2-.43 13.77-.6 7.58-1.38 13.7-1.74 13.67-.36-.03-.17-6.2.43-13.77Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aw)",
    d: "M301.79 87.6h5.6v19.16h-5.6z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ax)",
    d: "M353.68 110.72c5.7-5.02 10.52-8.88 10.76-8.6.24.27-4.2 4.56-9.9 9.59-5.7 5.02-10.52 8.88-10.76 8.6-.24-.27 4.2-4.56 9.9-9.59Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M353.68 110.72c5.7-5.02 10.52-8.88 10.76-8.6.24.27-4.2 4.56-9.9 9.59-5.7 5.02-10.52 8.88-10.76 8.6-.24-.27 4.2-4.56 9.9-9.59Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ay)",
    d: "M346.62 104.11h15.49v14.19h-15.49z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#az)",
    d: "M355.33 126.12c5.7-5.03 10.53-8.88 10.77-8.6.24.26-4.2 4.56-9.9 9.59-5.7 5.02-10.52 8.88-10.76 8.6-.24-.27 4.2-4.56 9.9-9.59Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M355.33 126.12c5.7-5.03 10.53-8.88 10.77-8.6.24.26-4.2 4.56-9.9 9.59-5.7 5.02-10.52 8.88-10.76 8.6-.24-.27 4.2-4.56 9.9-9.59Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aA)",
    d: "M348.26 119.54h15.55v14.13h-15.55z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aB)",
    d: "M324.86 53.7c1.53-7.45 3.05-13.43 3.4-13.35.36.07-.59 6.17-2.11 13.61-1.53 7.45-3.06 13.43-3.41 13.36-.36-.08.6-6.17 2.12-13.62Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M324.86 53.7c1.53-7.45 3.05-13.43 3.4-13.35.36.07-.59 6.17-2.11 13.61-1.53 7.45-3.06 13.43-3.41 13.36-.36-.08.6-6.17 2.12-13.62Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aC)",
    d: "M322.09 44.18h7.29v18.94h-7.29z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aD)",
    d: "M376.76 70.97c7.6-.06 13.77.19 13.77.55 0 .36-6.16.7-13.76.76-7.6.06-13.77-.2-13.77-.55 0-.37 6.16-.7 13.76-.76Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M376.76 70.97c7.6-.06 13.77.19 13.77.55 0 .36-6.16.7-13.76.76-7.6.06-13.77-.2-13.77-.55 0-.37 6.16-.7 13.76-.76Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aE)",
    d: "M367.37 69.34h19.22v4.92h-19.22z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aF)",
    d: "M306.48 82.12h6.95v17.69h-6.95z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aG)",
    d: "M353.63 107.84h14.64v14.3h-14.64z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aH)",
    d: "M306.48 82.12h6.95v17.69h-6.95z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI)",
    d: "M353.63 107.84h14.64v14.3h-14.64z"
  })), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-13",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aJ)",
    d: "M306.48 82.12h6.95v17.69h-6.95z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aK)",
    d: "M353.63 107.84h14.64v14.3h-14.64z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aL)",
    d: "M306.48 82.12h6.95v17.69h-6.95z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aM)",
    d: "M353.63 107.84h14.64v14.3h-14.64z"
  })), _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-13",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-13",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    filter: "url(#aN)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.14 126H25v7.14h7.14V126ZM343.14 181H336v7.14h7.14V181ZM195.14 395H188v7.14h7.14V395ZM228.14 123H221v7.14h7.14V123ZM123.31 724.94h-7.14v7.14h7.14v-7.14ZM22.14 669H15v7.14h7.14V669Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.87 544.5 14.78-17.22c2-2.33 1.75-5.9-.57-7.92a5.56 5.56 0 0 0-7.87.58L12.5 535.9l-13.71-15.97a5.56 5.56 0 0 0-7.87-.58 5.66 5.66 0 0 0-.57 7.92L5.13 544.5l-14.78 17.22c-2 2.33-1.75 5.9.57 7.92a5.56 5.56 0 0 0 7.87-.58L12.5 553.1l13.71 15.97c2.01 2.34 5.55 2.6 7.87.58a5.66 5.66 0 0 0 .57-7.92L19.87 544.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M355.14 478H348v7.14h7.14V478Z"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#aO)"
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aP)",
    d: "M-36 151h97.02v84.57H-36z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aQ)",
    d: "M-36 151h97.02v84.57H-36z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aR)",
    d: "M-36 151h97.02v84.57H-36z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aS)",
    d: "M-36 151h97.02v84.57H-36z"
  })), _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-14",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-15",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "m-19.11 205.12 8.24-15.7c.88-1.7 2.85-2.42 4.38-1.62l34.3 18c1.52.8 2.04 2.83 1.16 4.51l-8.3 15.83M44.91 180.36l-10.87 20.71-40.08-21.02 11.05-21.07M44.5 191.2l11.23 5.88M41.2 198.13l11.22 5.89M37.35 205.84l11.22 5.88M32.73 214.5l11.23 5.88"
  })), _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-16",
    strokeMiterlimit: 10
  })), _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-14",
    strokeMiterlimit: 10
  })), _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-15",
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "m-19.11 205.12 8.24-15.7c.88-1.7 2.85-2.42 4.38-1.62l34.3 18c1.52.8 2.04 2.83 1.16 4.51l-8.3 15.83M44.91 180.36l-10.87 20.71-40.08-21.02 11.05-21.07M44.5 191.2l11.23 5.88M41.2 198.13l11.22 5.89M36.73 205.66l11.23 5.88M32.11 214.31l11.23 5.9"
  })), _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-16",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aT)",
    d: "M-2.45 169.44c3.5-6.45 6.91-11.37 7.64-10.97.72.39-1.52 5.94-5.02 12.39-3.5 6.45-6.91 11.36-7.64 10.97-.72-.4 1.53-5.94 5.02-12.4Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M-2.45 169.44c3.5-6.45 6.91-11.37 7.64-10.97.72.39-1.52 5.94-5.02 12.39-3.5 6.45-6.91 11.36-7.64 10.97-.72-.4 1.53-5.94 5.02-12.4Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aU)",
    d: "M-6.32 161.63H4.93v17.02H-6.32z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aV)",
    d: "M45.62 213.22c3.5-6.45 6.91-11.36 7.64-10.97.72.4-1.52 5.94-5.02 12.4-3.5 6.45-6.91 11.36-7.64 10.97-.72-.4 1.53-5.94 5.02-12.4Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M45.62 213.22c3.5-6.45 6.91-11.36 7.64-10.97.72.4-1.52 5.94-5.02 12.4-3.5 6.45-6.91 11.36-7.64 10.97-.72-.4 1.53-5.94 5.02-12.4Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aW)",
    d: "M41.74 205.44h11.25v16.96H41.74z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aX)",
    d: "M39.7 174.15c6.55 3.32 11.55 6.61 11.17 7.35-.37.73-5.97-1.37-12.52-4.69-6.54-3.32-11.54-6.6-11.17-7.34.38-.73 5.98 1.36 12.52 4.68Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M39.7 174.15c6.55 3.32 11.55 6.61 11.17 7.35-.37.73-5.97-1.37-12.52-4.69-6.54-3.32-11.54-6.6-11.17-7.34.38-.73 5.98 1.36 12.52 4.68Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aY)",
    d: "M30.49 170.45h17.13v10.91H30.49z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aZ)",
    d: "M27.34 179.11c3.5 2.37 5.96 4.85 5.5 5.53-.47.68-3.68-.69-7.18-3.06-3.5-2.37-5.96-4.84-5.5-5.53.47-.68 3.68.7 7.18 3.06Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M27.34 179.11c3.5 2.37 5.96 4.85 5.5 5.53-.47.68-3.68-.69-7.18-3.06-3.5-2.37-5.96-4.84-5.5-5.53.47-.68 3.68.7 7.18 3.06Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ba)",
    d: "M20.82 176.21h11.14v9.05H20.82z",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#bb)"
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bc)",
    d: "M276.59 711.02h40.89v40.8h-40.89z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bd)",
    d: "M301.62 673h53.89v48.82h-53.89z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#be)",
    d: "M307.73 682.84h40.13v36.02h-40.13z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bf)",
    d: "M257 692.78h178v126.97H257z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bg)",
    d: "M270.28 704.34h54.94v54.84h-54.94z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bh)",
    d: "M369.55 752.3h54.94v54.94h-54.94z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bi)",
    d: "M380.92 758.13h38.22v28.85h-38.22z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bj)",
    d: "M374.81 770.83h38.22v28.85h-38.22z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bk)",
    d: "M314.14 747.04h22.36v18.15h-22.36z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bl)",
    d: "M329.61 754.5h22.36v18.15h-22.36z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bm)",
    d: "M345.09 762.04h22.36v18.15h-22.36z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bn)",
    d: "M276.59 711.02h40.89v40.8h-40.89z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bo)",
    d: "M301.62 673h53.89v48.82h-53.89z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bp)",
    d: "M307.73 682.84h40.13v36.02h-40.13z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bq)",
    d: "M257 692.78h178v126.97H257z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#br)",
    d: "M270.28 704.34h54.94v54.84h-54.94z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bs)",
    d: "M369.55 752.3h54.94v54.94h-54.94z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bt)",
    d: "M380.92 758.13h38.22v28.85h-38.22z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bu)",
    d: "M374.81 770.83h38.22v28.85h-38.22z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bv)",
    d: "M314.14 747.04h22.36v18.15h-22.36z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bw)",
    d: "M329.61 754.5h22.36v18.15h-22.36z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bx)",
    d: "M345.09 762.04h22.36v18.15h-22.36z"
  })), _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-17",
    strokeMiterlimit: 10
  })), _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-18",
    strokeMiterlimit: 10
  })), _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-19",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-20",
    strokeMiterlimit: 10
  })), _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-21",
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#by)",
    d: "M276.59 711.02h40.89v40.8h-40.89z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bz)",
    d: "M301.62 673h53.89v48.82h-53.89z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bA)",
    d: "M307.73 682.84h40.13v36.02h-40.13z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bB)",
    d: "M257 692.78h178v126.97H257z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bC)",
    d: "M270.28 704.34h54.94v54.84h-54.94z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bD)",
    d: "M369.55 752.3h54.94v54.94h-54.94z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bE)",
    d: "M380.92 758.13h38.22v28.85h-38.22z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bF)",
    d: "M374.81 770.83h38.22v28.85h-38.22z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bG)",
    d: "M314.14 747.04h22.36v18.15h-22.36z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bH)",
    d: "M329.61 754.5h22.36v18.15h-22.36z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bI)",
    d: "M345.09 762.04h22.36v18.15h-22.36z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bJ)",
    d: "M276.59 711.02h40.89v40.8h-40.89z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bK)",
    d: "M301.62 673h53.89v48.82h-53.89z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bL)",
    d: "M307.73 682.84h40.13v36.02h-40.13z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bM)",
    d: "M257 692.78h178v126.97H257z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bN)",
    d: "M270.28 704.34h54.94v54.84h-54.94z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bO)",
    d: "M369.55 752.3h54.94v54.94h-54.94z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bP)",
    d: "M380.92 758.13h38.22v28.85h-38.22z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bQ)",
    d: "M374.81 770.83h38.22v28.85h-38.22z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bR)",
    d: "M314.14 747.04h22.36v18.15h-22.36z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bS)",
    d: "M329.61 754.5h22.36v18.15h-22.36z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bT)",
    d: "M345.09 762.04h22.36v18.15h-22.36z"
  })), _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-17",
    strokeMiterlimit: 10
  })), _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-18",
    strokeMiterlimit: 10
  })), _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-19",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-20",
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "m406.8 781.65-18.05-8.73a5.28 5.28 0 0 1-2.44-7.03 5.28 5.28 0 0 1 7.04-2.45l18.04 8.73a5.28 5.28 0 0 1 2.45 7.04 5.28 5.28 0 0 1-7.04 2.44ZM400.64 794.38l-18.04-8.73a5.28 5.28 0 0 1-2.45-7.04 5.28 5.28 0 0 1 7.04-2.45l18.04 8.73a5.28 5.28 0 0 1 2.45 7.04 5.28 5.28 0 0 1-7.04 2.45ZM328.47 760.13l-8.27-4a2.25 2.25 0 0 1-1.04-3 2.25 2.25 0 0 1 2.99-1.04l8.27 4a2.25 2.25 0 0 1 1.04 3 2.25 2.25 0 0 1-2.99 1.03ZM343.96 767.62l-8.27-4a2.24 2.24 0 0 1-1.04-3 2.25 2.25 0 0 1 2.99-1.03l8.27 4a2.24 2.24 0 0 1-1.95 4.03ZM359.45 775.11l-8.28-4a2.25 2.25 0 0 1-1.04-3 2.25 2.25 0 0 1 3-1.03l8.27 4a2.25 2.25 0 0 1 1.04 3 2.25 2.25 0 0 1-3 1.03ZM310.45 732.88l-7.35-3.56 3.55-7.35a3.92 3.92 0 0 0-1.81-5.22l-1.12-.54a3.92 3.92 0 0 0-5.22 1.82l-3.56 7.35-7.35-3.56a3.92 3.92 0 0 0-5.22 1.82l-.54 1.11a3.92 3.92 0 0 0 1.82 5.22l7.35 3.56-3.56 7.35a3.92 3.92 0 0 0 1.82 5.22l1.11.54c1.94.94 4.29.12 5.22-1.81l3.56-7.36 7.35 3.56c1.94.94 4.29.12 5.22-1.81l.54-1.12a3.92 3.92 0 0 0-1.81-5.22ZM346.89 717.84c6.82-16.54 4.2-33.34-6.43-38.48-10.62-5.14-25.42 3.23-34.16 18.84"
  })), _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-18",
    strokeMiterlimit: 10
  })), _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-19",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-20",
    strokeMiterlimit: 10
  })), _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-21",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bU)",
    d: "M335.3 780.05c18.07 8.74 32.28 16.71 31.75 17.81-.53 1.1-15.6-5.08-33.67-13.82-18.07-8.73-32.28-16.7-31.75-17.8.53-1.1 15.61 5.08 33.68 13.81Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M335.3 780.05c18.07 8.74 32.28 16.71 31.75 17.81-.53 1.1-15.6-5.08-33.67-13.82-18.07-8.73-32.28-16.7-31.75-17.8.53-1.1 15.61 5.08 33.68 13.81Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bV)",
    d: "M313.18 770.55h42.9v24.55h-42.9z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bW)",
    d: "M380.11 731.4c18.07 8.74 32.28 16.71 31.75 17.81-.53 1.1-15.61-5.08-33.68-13.82-18.06-8.73-32.28-16.7-31.74-17.8.53-1.11 15.6 5.08 33.67 13.81Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M380.11 731.4c18.07 8.74 32.28 16.71 31.75 17.81-.53 1.1-15.61-5.08-33.68-13.82-18.06-8.73-32.28-16.7-31.74-17.8.53-1.11 15.6 5.08 33.67 13.81Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bX)",
    d: "M357.99 721.92h42.9v24.46h-42.9z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bY)",
    d: "M396.04 778.5c7.57 3.66 13.5 7.08 13.22 7.63-.26.55-6.62-1.97-14.19-5.63-7.57-3.66-13.5-7.08-13.23-7.63.27-.55 6.62 1.97 14.2 5.63Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M396.04 778.5c7.57 3.66 13.5 7.08 13.22 7.63-.26.55-6.62-1.97-14.19-5.63-7.57-3.66-13.5-7.08-13.23-7.63.27-.55 6.62 1.97 14.2 5.63Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bZ)",
    d: "M384.65 772.65h22.07v14.43h-22.07z",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ca)"
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cb)",
    d: "M-37 311H82v123.64H-37z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cc)",
    d: "M-27.13 321.01h98.1v100.85h-98.1z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cd)",
    d: "M.73 332.77h37.44v65.59H.73z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ce)",
    d: "M-37 311H82v123.64H-37z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cf)",
    d: "M-27.13 321.01h98.1v100.85h-98.1z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cg)",
    d: "M.73 332.77h37.44v65.59H.73z"
  })), _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-22",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-23",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-24",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ch)",
    d: "M-37 311H82v123.64H-37z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ci)",
    d: "M-27.13 321.01h98.1v100.85h-98.1z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cj)",
    d: "M.73 332.77h37.44v65.59H.73z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ck)",
    d: "M-37 311H82v123.64H-37z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cl)",
    d: "M-27.13 321.01h98.1v100.85h-98.1z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cm)",
    d: "M.73 332.77h37.44v65.59H.73z"
  })), _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-22",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-23",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-24",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-22",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-23",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-24",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cn)",
    d: "M-9.83 389.82c10.5 20.89 18.27 38.19 17.36 38.64-.91.46-10.16-16.1-20.65-36.98-10.5-20.88-18.27-38.19-17.36-38.64.91-.46 10.16 16.1 20.65 36.98Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M-9.83 389.82c10.5 20.89 18.27 38.19 17.36 38.64-.91.46-10.16-16.1-20.65-36.98-10.5-20.88-18.27-38.19-17.36-38.64.91-.46 10.16 16.1 20.65 36.98Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#co)",
    d: "M-27.42 365.42H4.22v52.1h-31.64z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cp)",
    d: "M58.78 368.82c6.51 14.35 11.03 26.33 10.1 26.75-.92.42-6.95-10.87-13.46-25.22-6.5-14.36-11.03-26.33-10.1-26.75.92-.42 6.95 10.87 13.46 25.22Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M58.78 368.82c6.51 14.35 11.03 26.33 10.1 26.75-.92.42-6.95-10.87-13.46-25.22-6.5-14.36-11.03-26.33-10.1-26.75.92-.42 6.95 10.87 13.46 25.22Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cq)",
    d: "M44.99 350.62h23.8v39.18h-23.8z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cr)",
    d: "M70.38 375.32c6.5 14.35 11.03 26.33 10.1 26.75-.92.42-6.95-10.87-13.46-25.22-6.5-14.35-11.03-26.33-10.1-26.75.92-.42 6.95 10.87 13.46 25.22Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M70.38 375.32c6.5 14.35 11.03 26.33 10.1 26.75-.92.42-6.95-10.87-13.46-25.22-6.5-14.35-11.03-26.33-10.1-26.75.92-.42 6.95 10.87 13.46 25.22Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cs)",
    d: "M56.6 357.15h23.8v39.18H56.6z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ct)",
    d: "M31.87 368c-1.53 15.69-3.6 28.32-4.6 28.22-1.02-.1-.6-12.89.93-28.57 1.54-15.69 3.6-28.32 4.61-28.22 1.02.1.6 12.9-.94 28.58Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M31.87 368c-1.53 15.69-3.6 28.32-4.6 28.22-1.02-.1-.6-12.89.93-28.57 1.54-15.69 3.6-28.32 4.61-28.22 1.02.1.6 12.9-.94 28.58Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cu)",
    d: "M22.35 347.28h14.37v41.79H22.35z",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cv)"
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cw)",
    d: "M164 634h49.58v49.52H164z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cx)",
    d: "M179.15 649.09h19.28v19.33h-19.28z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cy)",
    d: "M182.77 652.71h12.1v12.1h-12.1z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cz)",
    d: "M169.71 661.02h17.36v14.87h-17.36z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cA)",
    d: "M192.55 644.63h17.3v14.92h-17.3z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cB)",
    d: "M164 634h49.58v49.52H164z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cC)",
    d: "M179.15 649.09h19.28v19.33h-19.28z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cD)",
    d: "M182.77 652.71h12.1v12.1h-12.1z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cE)",
    d: "M169.71 661.02h17.36v14.87h-17.36z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cF)",
    d: "M192.55 644.63h17.3v14.92h-17.3z"
  })), _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-25",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-26",
    strokeMiterlimit: 10
  })), _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-27",
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cG)",
    d: "M182.77 652.71h12.1v12.1h-12.1z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cH)",
    d: "M169.71 661.02h17.36v14.87h-17.36z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cI)",
    d: "M192.55 644.63h17.3v14.92h-17.3z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cJ)",
    d: "M164 634h49.58v49.52H164z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cK)",
    d: "M179.15 649.09h19.28v19.33h-19.28z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cL)",
    d: "M182.77 652.71h12.1v12.1h-12.1z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cM)",
    d: "M169.71 661.02h17.36v14.87h-17.36z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cN)",
    d: "M192.55 644.63h17.3v14.92h-17.3z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cO)",
    d: "M164 634h49.58v49.52H164z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cP)",
    d: "M179.15 649.09h19.28v19.33h-19.28z"
  })), _use66 || (_use66 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-27",
    strokeMiterlimit: 10
  })), _use67 || (_use67 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-25",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use68 || (_use68 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-26",
    strokeMiterlimit: 10
  })), _use69 || (_use69 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-27",
    strokeMiterlimit: 10
  })), _use70 || (_use70 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-25",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use71 || (_use71 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-26",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cQ)",
    d: "M193.79 664.22c-3.77 2.8-7 4.84-7.22 4.55-.22-.3 2.66-2.8 6.44-5.6 3.77-2.8 7-4.84 7.22-4.55.22.3-2.67 2.8-6.44 5.6Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M193.79 664.22c-3.77 2.8-7 4.84-7.22 4.55-.22-.3 2.66-2.8 6.44-5.6 3.77-2.8 7-4.84 7.22-4.55.22.3-2.67 2.8-6.44 5.6Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cR)",
    d: "M187.35 658.76h11.7v9.78h-11.7z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cS)",
    d: "M202.86 676.9c-3.78 2.8-7.15 4.65-7.54 4.13-.39-.53 2.36-3.22 6.13-6.02 3.78-2.8 7.15-4.65 7.54-4.13.38.52-2.36 3.22-6.13 6.02Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M202.86 676.9c-3.78 2.8-7.15 4.65-7.54 4.13-.39-.53 2.36-3.22 6.13-6.02 3.78-2.8 7.15-4.65 7.54-4.13.38.52-2.36 3.22-6.13 6.02Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cT)",
    d: "M196 670.86h11.7v9.84H196z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cU)",
    d: "M176.16 642.49c-3.78 2.8-7.15 4.65-7.54 4.13-.39-.53 2.36-3.22 6.13-6.03 3.77-2.8 7.15-4.65 7.53-4.12.4.52-2.35 3.21-6.12 6.02Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M176.16 642.49c-3.78 2.8-7.15 4.65-7.54 4.13-.39-.53 2.36-3.22 6.13-6.03 3.77-2.8 7.15-4.65 7.53-4.12.4.52-2.35 3.21-6.12 6.02Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cV)",
    d: "M169.31 636.49h11.7v9.84h-11.7z",
    style: {
      mixBlendMode: "overlay"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cX)",
    d: "M334 262h107v114.79H334z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cY)",
    d: "M334 262h107v114.79H334z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-28",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cZ)",
    d: "M334 262h107v114.79H334z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#da)",
    d: "M334 262h107v114.79H334z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-28",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-28",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#db)"
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dc)",
    d: "M16-2h104.42v89.49H16z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dd)",
    d: "M37.26 6.59h43.25V46.5H37.26z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#de)",
    d: "M44.49 15.58h24.2v24.48h-24.2z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#df)",
    d: "M16-2h104.42v89.49H16z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dg)",
    d: "M37.26 6.59h43.25V46.5H37.26z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dh)",
    d: "M44.49 15.58h24.2v24.48h-24.2z"
  })), _use72 || (_use72 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-29",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use73 || (_use73 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-30",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use74 || (_use74 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-31",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#di)",
    d: "M16-2h104.42v89.49H16z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dj)",
    d: "M37.26 6.59h43.25V46.5H37.26z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dk)",
    d: "M44.21 15.3h24.71v25.04H44.21z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dl)",
    d: "M16-2h104.42v89.49H16z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dm)",
    d: "M37.26 6.59h43.25V46.5H37.26z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dn)",
    d: "M44.21 15.3h24.71v25.04H44.21z"
  })), _use75 || (_use75 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-29",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use76 || (_use76 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-30",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use77 || (_use77 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-31",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use78 || (_use78 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-29",
    strokeMiterlimit: 10
  })), _use79 || (_use79 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-30",
    strokeMiterlimit: 10
  })), _use80 || (_use80 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-31",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#do)",
    d: "M54.47 17c-6.68 2.94-12.28 4.9-12.5 4.4-.23-.5 5-3.3 11.7-6.23 6.67-2.94 12.27-4.9 12.5-4.4.22.51-5.02 3.3-11.7 6.24Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M54.47 17c-6.68 2.94-12.28 4.9-12.5 4.4-.23-.5 5-3.3 11.7-6.23 6.67-2.94 12.27-4.9 12.5-4.4.22.51-5.02 3.3-11.7 6.24Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dp)",
    d: "M45.06 10.89h17.41v10.12H45.06z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dq)",
    d: "M23.63 68.44c-2.3-6.92-3.73-12.68-3.2-12.85.52-.18 2.8 5.3 5.1 12.22 2.3 6.93 3.74 12.69 3.21 12.86-.52.17-2.81-5.3-5.11-12.23Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M23.63 68.44c-2.3-6.92-3.73-12.68-3.2-12.85.52-.18 2.8 5.3 5.1 12.22 2.3 6.93 3.74 12.69 3.21 12.86-.52.17-2.81-5.3-5.11-12.23Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dr)",
    d: "M20.35 58.89h8.82v17.92h-8.82z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ds)",
    d: "M111.87 31.95c-3.43-6.44-5.8-11.88-5.31-12.14.49-.26 3.66 4.76 7.08 11.2 3.42 6.45 5.8 11.88 5.31 12.14-.49.26-3.66-4.75-7.08-11.2Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M111.87 31.95c-3.43-6.44-5.8-11.88-5.31-12.14.49-.26 3.66 4.76 7.08 11.2 3.42 6.45 5.8 11.88 5.31 12.14-.49.26-3.66-4.75-7.08-11.2Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dt)",
    d: "M107.36 22.7h11.02v16.96h-11.02z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#du)",
    d: "M61.76 29.92c-1.9-2.28-3.16-4.37-2.8-4.67.36-.3 2.2 1.3 4.1 3.59 1.9 2.28 3.15 4.37 2.8 4.67-.36.3-2.2-1.3-4.1-3.59Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M61.76 29.92c-1.9-2.28-3.16-4.37-2.8-4.67.36-.3 2.2 1.3 4.1 3.59 1.9 2.28 3.15 4.37 2.8 4.67-.36.3-2.2-1.3-4.1-3.59Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dv)",
    d: "M58.51 24.8h8.03v8.76h-8.03z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dw)",
    d: "M66.57 47.19c4-1.98 7.43-3.25 7.63-2.83.21.42-2.87 2.36-6.88 4.35-4 1.98-7.42 3.25-7.63 2.83-.2-.42 2.87-2.37 6.88-4.35Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M66.57 47.19c4-1.98 7.43-3.25 7.63-2.83.21.42-2.87 2.36-6.88 4.35-4 1.98-7.42 3.25-7.63 2.83-.2-.42 2.87-2.37 6.88-4.35Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dx)",
    d: "M61.12 43.96h12.1v8.2h-12.1z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dy)",
    d: "M45.51 43.51h13.57v13.62H45.51z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dz)",
    d: "M72.14 30.73h13.57v13.62H72.14z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dA)",
    d: "M74.91 4.33h17.02v13.68H74.91z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dB)",
    d: "M78.3 11.45h17.02v13.68H78.3z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dC)",
    d: "M23.12 28.3h10.69v10.74H23.12z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dD)",
    d: "M28.44 39.44h10.74v10.74H28.44z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dE)",
    d: "M31.43 31.02h10.74v10.74H31.43z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dF)",
    d: "M19.84 36.56h10.74V47.3H19.84z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dG)",
    d: "M45.51 43.51h13.57v13.62H45.51z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dH)",
    d: "M72.14 30.73h13.57v13.62H72.14z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dI)",
    d: "M74.91 4.33h17.02v13.68H74.91z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dJ)",
    d: "M78.3 11.45h17.02v13.68H78.3z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dK)",
    d: "M23.12 28.3h10.69v10.74H23.12z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dL)",
    d: "M28.44 39.44h10.74v10.74H28.44z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dM)",
    d: "M31.43 31.02h10.74v10.74H31.43z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dN)",
    d: "M19.84 36.56h10.74V47.3H19.84z"
  })), _use81 || (_use81 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-32",
    strokeMiterlimit: 10
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dO)",
    d: "M45.51 43.51h13.57v13.62H45.51z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dP)",
    d: "M72.14 30.73h13.57v13.62H72.14z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dQ)",
    d: "M74.91 4.33h17.02v13.68H74.91z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dR)",
    d: "M78.3 11.45h17.02v13.68H78.3z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dS)",
    d: "M23.12 28.3h10.69v10.74H23.12z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dT)",
    d: "M28.44 39.44h10.74v10.74H28.44z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dU)",
    d: "M31.43 31.02h10.74v10.74H31.43z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dV)",
    d: "M19.84 36.56h10.74V47.3H19.84z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dW)",
    d: "M45.51 43.51h13.57v13.62H45.51z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dX)",
    d: "M72.14 30.73h13.57v13.62H72.14z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dY)",
    d: "M74.91 4.33h17.02v13.68H74.91z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dZ)",
    d: "M78.3 11.45h17.02v13.68H78.3z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ea)",
    d: "M23.12 28.3h10.69v10.74H23.12z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eb)",
    d: "M28.44 39.44h10.74v10.74H28.44z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ec)",
    d: "M31.43 31.02h10.74v10.74H31.43z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ed)",
    d: "M19.84 36.56h10.74V47.3H19.84z"
  })), _use82 || (_use82 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-32",
    strokeMiterlimit: 10
  })), _use83 || (_use83 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-32",
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ee)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M157.14 560H150v7.14h7.14V560Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M157.14 560H150v7.14h7.14V560Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ef)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.14 460H33v7.14h7.14V460Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M40.14 460H33v7.14h7.14V460Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#eg)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.14 278H33v7.14h7.14V278Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M40.14 278H33v7.14h7.14V278Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#eh)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ei)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M151.14 59H144v7.14h7.14V59Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M151.14 59H144v7.14h7.14V59Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ej)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ek)",
    d: "M92 349h28.72v30.81H92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#el)",
    d: "M92 349h28.72v30.81H92z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-33",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#em)",
    d: "M92 349h28.72v30.81H92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#en)",
    d: "M92 349h28.72v30.81H92z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-33",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-33",
    strokeMiterlimit: 10
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#eo)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ep)",
    d: "M238-11h51.72v58.81H238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eq)",
    d: "M238-11h51.72v58.81H238z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-34",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#er)",
    d: "M238-11h51.72v58.81H238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#es)",
    d: "M238-11h51.72v58.81H238z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-34",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-34",
    strokeMiterlimit: 10
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#et)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eu)",
    d: "M69 80h46.9v50.89H69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ev)",
    d: "M69 80h46.9v50.89H69z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-35",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ew)",
    d: "M69 80h46.9v50.89H69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ex)",
    d: "M69 80h46.9v50.89H69z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-35",
    strokeMiterlimit: 10
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ey)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ez)",
    d: "M290 342h49v53.32h-49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eA)",
    d: "M290 342h49v53.32h-49z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-36",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eB)",
    d: "M290 342h49v53.32h-49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eC)",
    d: "M290 342h49v53.32h-49z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-36",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-36",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#eD)"
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eE)",
    d: "M332 526h80.9v75.19H332z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eF)",
    d: "M347.77 584.79h16.28v14.47h-16.28z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eG)",
    d: "M339.46 555h31.26v38.95h-31.26z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eH)",
    d: "M372.48 530.35h31.15v39.4h-31.15z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eI)",
    d: "M367.96 553.59h19.79v24.37h-19.79z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eJ)",
    d: "M355.69 545.84h28.49v30.19h-28.49z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eK)",
    d: "M358.8 545.62h27.14v34.6H358.8z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eL)",
    d: "M332 526h80.9v75.19H332z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eM)",
    d: "M347.77 584.79h16.28v14.47h-16.28z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eN)",
    d: "M339.46 555h31.26v38.95h-31.26z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eO)",
    d: "M372.48 530.35h31.15v39.4h-31.15z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eP)",
    d: "M367.96 553.59h19.79v24.37h-19.79z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eQ)",
    d: "M355.69 545.84h28.49v30.19h-28.49z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eR)",
    d: "M358.8 545.62h27.14v34.6H358.8z"
  })), _use84 || (_use84 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-37",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use85 || (_use85 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-38",
    strokeMiterlimit: 10
  })), _use86 || (_use86 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-39",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use87 || (_use87 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-40",
    strokeMiterlimit: 10
  })), _use88 || (_use88 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-41",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use89 || (_use89 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-37",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use90 || (_use90 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-38",
    strokeMiterlimit: 10
  })), _use91 || (_use91 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-39",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _use92 || (_use92 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-40",
    strokeMiterlimit: 10
  })), _use93 || (_use93 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-41",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eS)",
    d: "M351.61 567.27c7.35 9.33 12.84 17.25 12.27 17.7-.56.45-6.98-6.75-14.33-16.08-7.35-9.32-12.84-17.25-12.27-17.7.57-.45 6.99 6.75 14.33 16.08Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M351.61 567.27c7.35 9.33 12.84 17.25 12.27 17.7-.56.45-6.98-6.75-14.33-16.08-7.35-9.32-12.84-17.25-12.27-17.7.57-.45 6.99 6.75 14.33 16.08Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eT)",
    d: "M341.16 557.21h18.77v22.67h-18.77z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eU)",
    d: "M394.94 556.72c7.35 9.32 12.84 17.25 12.27 17.7-.57.45-6.98-6.75-14.33-16.08-7.35-9.33-12.84-17.25-12.27-17.7.56-.45 6.98 6.75 14.33 16.08Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M394.94 556.72c7.35 9.32 12.84 17.25 12.27 17.7-.57.45-6.98-6.75-14.33-16.08-7.35-9.33-12.84-17.25-12.27-17.7.56-.45 6.98 6.75 14.33 16.08Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eV)",
    d: "M384.46 546.63h18.77v22.73h-18.77z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eW)",
    d: "M380.1 583.89c-9.4 7.26-17.22 12.88-17.49 12.53-.26-.34 7.14-6.5 16.53-13.77s17.21-12.88 17.48-12.54c.26.34-7.13 6.51-16.52 13.78Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M380.1 583.89c-9.4 7.26-17.22 12.88-17.49 12.53-.26-.34 7.14-6.5 16.53-13.77s17.21-12.88 17.48-12.54c.26.34-7.13 6.51-16.52 13.78Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eX)",
    d: "M367.84 574h22.78v18.6h-22.78z",
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "b",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eY",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "c",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eZ",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "d",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fa",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "e",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fb",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "f",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fc",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "g",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fd",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "h",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fe",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "i",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ff",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "j",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fg",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "k",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fh",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "l",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fi",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "m",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fj",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "o",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fk",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "q",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fl",
    transform: "scale(0 .01)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "s",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fm",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "v",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fn",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "w",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fo",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "x",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fp",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "y",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fq",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "z",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fr",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "A",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fs",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "B",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ft",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "C",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fu",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "D",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fv",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "E",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fw",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "F",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fx",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "G",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fy",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "H",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fz",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "I",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fA",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "J",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fB",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "K",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fC",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "L",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fD",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "M",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fE",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "N",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fF",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "O",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fG",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "P",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fH",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Q",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fI",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "R",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fJ",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "S",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fK",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "T",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fn",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "U",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fo",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "V",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fp",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "W",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fq",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "X",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fr",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Y",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fs",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Z",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ft",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aa",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fu",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ab",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fv",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ac",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fw",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ad",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fx",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ae",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fy",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "af",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fz",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ag",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fA",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ah",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fB",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ai",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fC",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aj",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fD",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ak",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fE",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "al",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fF",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "am",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fG",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "an",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fH",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ao",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fI",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ap",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fJ",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aq",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fK",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "as",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fL",
    transform: "scale(.01 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "au",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fM",
    transform: "scale(.01 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aw",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fN",
    transform: "scale(.01 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ay",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fO",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aA",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fP",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aC",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fQ",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aE",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fR",
    transform: "scale(0 .01)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aF",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fS",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aG",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fT",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aH",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fU",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aI",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fV",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aJ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fS",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aK",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fT",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aL",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fU",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aM",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fV",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aP",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fW",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aQ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fX",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aR",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fW",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aS",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fX",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aU",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fY",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aW",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fZ",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aY",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ga",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ba",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gb",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bc",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gc",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bd",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gd",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "be",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ge",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bf",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gf",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bg",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gg",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bh",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gh",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bi",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gi",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bj",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gj",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bk",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gk",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bl",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gl",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bm",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gm",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bn",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gn",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bo",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#go",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bp",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gp",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bq",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gq",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "br",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gr",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bs",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gs",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bt",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gt",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bu",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gu",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bv",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gv",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bw",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gw",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bx",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gx",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "by",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gc",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bz",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gd",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bA",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ge",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bB",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gf",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bC",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gg",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bD",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gh",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bE",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gi",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bF",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gj",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bG",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gk",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bH",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gl",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bI",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gm",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bJ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gn",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bK",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#go",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bL",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gp",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bM",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gq",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bN",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gr",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bO",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gs",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bP",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gt",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bQ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gu",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bR",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gv",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bS",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gw",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bT",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gx",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bV",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gy",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bX",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gz",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bZ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gA",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cb",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gB",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cc",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gC",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cd",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gD",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ce",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gE",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cf",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gF",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cg",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gG",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ch",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gB",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ci",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gH",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cj",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gD",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ck",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gE",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cl",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gI",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cm",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gG",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "co",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gJ",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cq",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gK",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cs",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gL",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cu",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gM",
    transform: "scale(.01 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cw",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gN",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cx",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gO",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cy",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gP",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cz",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gQ",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cA",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gR",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cB",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gS",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cC",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gT",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cD",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gU",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cE",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gV",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cF",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gW",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cG",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gP",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cH",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gQ",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cI",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gR",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cJ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gN",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cK",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gO",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cL",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gU",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cM",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gV",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cN",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gW",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cO",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gS",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cP",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gT",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cR",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gX",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cT",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gY",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cV",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gZ",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cX",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ha",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cY",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hb",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "cZ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ha",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "da",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hb",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dc",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hc",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dd",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hd",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "de",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#he",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "df",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hf",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dg",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hg",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dh",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hh",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "di",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hc",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dj",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hd",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dk",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hi",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dl",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hf",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dm",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hg",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dn",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hj",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dp",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hk",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dr",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hl",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dt",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hm",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dv",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hn",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dx",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ho",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dy",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hp",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dz",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hq",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dA",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hr",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dB",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hs",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dC",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ht",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dD",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hu",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dE",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hv",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dF",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hw",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dG",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hx",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dH",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hy",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dI",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hz",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dJ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hA",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dK",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hB",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dL",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hC",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dM",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hD",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dN",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hE",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dO",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hp",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dP",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hq",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dQ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hr",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dR",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hs",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dS",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ht",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dT",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hu",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dU",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hv",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dV",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hw",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dW",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hx",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dX",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hy",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dY",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hz",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dZ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hA",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ea",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hB",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eb",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hC",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ec",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hD",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ed",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hE",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ek",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ha",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "el",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hb",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "em",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ha",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "en",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hb",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ep",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hF",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eq",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hG",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "er",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hF",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "es",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hG",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eu",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hH",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ev",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hI",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ew",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hH",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ex",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hI",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ez",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hJ",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eA",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hK",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eB",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hJ",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eC",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hK",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eE",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hL",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eF",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hM",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eG",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hN",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eH",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hO",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eI",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hP",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eJ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hQ",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eK",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hR",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eL",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hS",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eM",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hT",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eN",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hU",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eO",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hV",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eP",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hW",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eQ",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hX",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eR",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hY",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eT",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hZ",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eV",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ia",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "eX",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ib",
    transform: "scale(0)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.65 -7.41 15.26 1.34 20.59 782.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.1 -7.44 15.32 .22 54.1 738)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.06 -2.35 4.84 14.54 19.9 734.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ar",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.7 -.3 .77 -9.78 316.64 98.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "at",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.7 -.3 .77 -9.78 323.85 102.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "av",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.7 -.3 .77 -9.78 304.4 97.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ax",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-131 202.14 -24.37) scale(3.72 9.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "az",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.46 -2.8 7.36 -6.49 355.77 126.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.64 -.75 1.97 -9.61 325.56 53.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.03 -3.72 9.81 -.07 376.77 71.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.44 -4.03 4.5 -8.32 -1.16 170.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.44 -4.03 4.5 -8.32 46.92 213.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-63 162.45 55.9) scale(8.46 9.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.75 -7 4.51 3.06 26.48 180.38)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-64 790.48 124.24) scale(12.57 25.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-64 774.08 64.21) scale(12.57 25.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.74 -5.66 9.77 4.72 395.56 779.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-27 818.06 219.1) scale(10.46 30.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(9.53 -4.32 8.4 18.52 57.07 369.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cr",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(9.53 -4.32 8.4 18.52 68.67 376.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ct",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.41 1.02 -1.98 20.24 30.06 367.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.22 2.99 -4.87 3.62 193.38 663.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(53 -570.88 539.29) scale(6.69 6.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(53 -550.03 495.52) scale(6.69 6.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "do",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(66 14.74 49.4) scale(5.69 9.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(162 6.8 36.05) scale(5.69 9.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ds",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(152 52.46 29.78) scale(5.69 9.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "du",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(140 25.9 26.01) scale(4.81 3.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-116 48.33 3.17) scale(4.8 5.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.85 -4.6 9.48 12.04 350.56 568.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.85 -4.6 9.48 12.04 393.9 557.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(52 -404.98 677.75) scale(4.45 15.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 99.93,
    height: 94.66,
    x: -15,
    y: 701,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "t",
    width: 16.14,
    height: 16.14,
    x: 287.5,
    y: 649.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u",
    width: 98.03,
    height: 104.38,
    x: 297,
    y: 39.85,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "aN",
    width: 8511.94,
    height: 6470.99,
    x: -4023,
    y: -3027,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "aO",
    width: 105.02,
    height: 92.57,
    x: -40,
    y: 151,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bb",
    width: 186,
    height: 154.75,
    x: 253,
    y: 673,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ca",
    width: 127,
    height: 131.64,
    x: -41,
    y: 311,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cv",
    width: 57.58,
    height: 57.52,
    x: 160,
    y: 634,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cW",
    width: 115,
    height: 122.79,
    x: 330,
    y: 262,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "db",
    width: 112.42,
    height: 97.49,
    x: 12,
    y: -2,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ee",
    width: 16.14,
    height: 16.14,
    x: 145.5,
    y: 559.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ef",
    width: 16.14,
    height: 16.14,
    x: 28.5,
    y: 459.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "eg",
    width: 16.14,
    height: 16.14,
    x: 28.5,
    y: 277.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "eh",
    width: 16.14,
    height: 16.14,
    x: 389.61,
    y: 280.75,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ei",
    width: 16.14,
    height: 16.14,
    x: 139.5,
    y: 58.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ej",
    width: 36.72,
    height: 38.81,
    x: 88,
    y: 349,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "eo",
    width: 59.72,
    height: 66.81,
    x: 234,
    y: -11,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "et",
    width: 54.9,
    height: 58.89,
    x: 65,
    y: 80,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ey",
    width: 57,
    height: 61.32,
    x: 286,
    y: 342,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "eD",
    width: 88.9,
    height: 83.19,
    x: 328,
    y: 526,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1015_610",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundStart);
export default __webpack_public_path__ + "static/media/backgroundStart.420b973ef8f3e97c38650a91d12b11f2.svg";
export { ForwardRef as ReactComponent };